import _extends from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
var __jsx = React.createElement;
import { getLinkTarget } from '@anm/helpers/upgradeLink';
import styled from 'styled-components';
import Button from './Button';
var LinkWrapper = styled(Button.withComponent('a')).withConfig({
  componentId: "sc-17nnn0g-0"
})(["text-decoration:none;"]);

var Link = function Link(_ref) {
  var newWindow = _ref.newWindow,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["newWindow", "children"]);

  return __jsx(LinkWrapper, _extends({
    target: newWindow ? getLinkTarget() : '_self'
  }, restProps), children);
};

export default Link;